import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { setProject as setProjectDispatch } from "../redux/app/appActions";

export const useProject = () => {
  const { project } = useSelector((state) => state.app);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const setProject = useCallback(
    (project, userId) => dispatch(setProjectDispatch(project, userId)),
    [dispatch],
  );

  useEffect(() => {
    if (project && user?.id) {
      setProject(project, user?.id);
    }
  }, [navigate, project, setProject, user?.id]);

  return { project, setProject };
};
